import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import { canAccessRoute, parsePermissions, canLoadSubsiteList } from '@/utils/permission'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login']

/** 合并并发导航时的用户信息/驿站加载，避免快速切菜单触发 Navigation cancelled */
let bootstrapPromise = null

function ensureBootstrap() {
  if (bootstrapPromise) {
    return bootstrapPromise
  }
  bootstrapPromise = (async () => {
    if (!store.getters.name) {
      await store.dispatch('user/getInfo')
    }
    // 驿站管理员无权访问驿站列表接口；无 SubSite 权限的总站账号也不拉全量列表
    if (!store.getters.isStationAdmin && !store.getters.subSiteList.length
        && canLoadSubsiteList(store.getters.permissions)) {
      await store.dispatch('app/loadSubSites')
    }
  })().catch(err => {
    bootstrapPromise = null
    throw err
  })
  return bootstrapPromise
}

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      NProgress.done()
      return next({ path: '/' })
    }
    try {
      if (!store.getters.name || (
        !store.getters.isStationAdmin
        && !store.getters.subSiteList.length
        && canLoadSubsiteList(store.getters.permissions)
      )) {
        await ensureBootstrap()
      }
      const permissions = store.getters.permissions
      const parsed = parsePermissions(permissions)
      if (parsed.length && !canAccessRoute(permissions, to)) {
        NProgress.done()
        return next({ path: '/dashboard', replace: true })
      }
      next()
    } catch {
      bootstrapPromise = null
      await store.dispatch('user/resetToken')
      NProgress.done()
      next(`/login?redirect=${to.fullPath}`)
    }
  } else if (whiteList.includes(to.path)) {
    bootstrapPromise = null
    next()
  } else {
    bootstrapPromise = null
    NProgress.done()
    next(`/login?redirect=${to.fullPath}`)
  }
})

router.afterEach(() => {
  NProgress.done()
})
